import { useEffect } from 'react';

import { useUiStore } from '@/store/ui/ui.store';

export const useLoaders = (isLoading: boolean) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  useEffect(() => {
    setIsGlobalLoading(isLoading);

    return () => {
      setIsGlobalLoading(false);
    };
  }, [isLoading, setIsGlobalLoading]);
};
